export default __webpack_public_path__ + "static/media/background_points.9576a9b6.svg";